import React, {HTMLAttributeAnchorTarget} from 'react';
import 'bulma/css/bulma.min.css';
import {unstable_HistoryRouter as HistoryRouter} from 'react-router-dom';
import {Block, Button, Container, Navbar} from 'react-bulma-components';
import AppRoutes from './AppRoutes';
import {useAuthContext} from './contexts/auth.context';
import {history} from './utils/history.utils';
import {NavLink} from 'react-router-dom';

const App: React.FC = () => {
  const auth = useAuthContext();

  const logout = async (): Promise<void> => {
    await auth.logout();
    history.replace('/');
  };

  const renderNavigationLink = (
    text: string,
    path: string,
    target?: HTMLAttributeAnchorTarget
  ): React.ReactElement => (
    <Navbar.Item>
      <NavLink
        to={path}
        caseSensitive
        target={target}
        className={({isActive}) => isActive ? 'has-text-weight-bold' : ''}
      >
        {text}
      </NavLink>
    </Navbar.Item>
  );

  return (
    <HistoryRouter history={history}>
      <Container>
        {auth.user && (
          <header>
            <Navbar color="light">
              <Navbar.Container>
                {renderNavigationLink('Checkout', '/checkout')}
                {renderNavigationLink('Check status', '/verify')}
                {renderNavigationLink('JWS', '/jws')}
                {renderNavigationLink('WebAuthn', '/webauthn')}
                {renderNavigationLink('API Docs', '/api.html', '_blank')}
                {renderNavigationLink('Seq diagram', '/3ds-flow.png', '_blank')}
              </Navbar.Container>

              <Navbar.Container align="right">
                <Navbar.Item href="#">
                  <Button color='danger' onClick={logout}>
                    Logout
                  </Button>
                </Navbar.Item>
              </Navbar.Container>
            </Navbar>
          </header>
        )}

        <Block>
          <AppRoutes />
        </Block>
      </Container>
    </HistoryRouter>
  );
};

export default App;
